import gql from 'graphql-tag'

export const SERVICES = gql`
  query Services($filter: ServicesFilter) {
    services(filter: $filter) {
      isSuccessful
      message
      services {
        data {
          serviceId
          companyId
          name
          serviceActionId
          serviceCategoryId
          serviceAction {
            serviceActionId
            action
          }
          serviceCategory {
            serviceCategoryId
            name
          }
          totalService2Ssgroup
          totalServiceSchedule
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const CREATE_SERVICES = gql`
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      isSuccessful
      message
      createService {
        serviceId
        name
        serviceActionId
        serviceCategoryId
        serviceAction {
          serviceActionId
          action
        }
        serviceCategory {
          serviceCategoryId
          name
        }
      }
    }
  }
`

export const UPDATE_SERVICES = gql`
  mutation UpdateService($input: UpdateServiceInput!) {
    updateService(input: $input) {
      isSuccessful
      message
      updateService {
        serviceId
        name
        serviceActionId
        serviceCategoryId
        serviceAction {
          serviceActionId
          action
        }
        serviceCategory {
          serviceCategoryId
          name
        }
      }
    }
  }
`

export const DELETE_SERVICES = gql`
  mutation DeleteService($input: DeleteServiceInput!) {
    deleteService(input: $input) {
      isSuccessful
      message
      errorName
      errorCode
      deleteService {
        serviceId
        name
        serviceActionId
        serviceCategoryId
        serviceAction {
          serviceActionId
          action
        }
        serviceCategory {
          serviceCategoryId
          name
        }
      }
    }
  }
`
